import { FC } from 'react'

import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import { EmbroideryItemCustomProperties } from '../../../containers/EmbroideryContainer/types'
import { formatPlacementAttribute } from '../../../containers/EmbroideryContainer/utils/formatPlacementAttribute'
import { B2bLogoSneakPeek } from '../EmbroiderySneakPeek/B2bLogoSneakPeek'
import { DTCLogoSneakPeek } from '../EmbroiderySneakPeek/DTCLogoSneakpeek'
import { IconSneakPeek } from '../EmbroiderySneakPeek/IconSneakPeek'
import { TextSneakPeek } from '../EmbroiderySneakPeek/TextSneakPeek'

import { EmbroideryTitle } from './styles'

interface Props {
  properties: EmbroideryItemCustomProperties
  hasLogoSetup: boolean
}

/**
 * Legacy (v1.5) display for embroidery sneak peeks within an `EmbroideryGroupContent`.
 *
 * Supports B2B and D2C embroidery.
 */
export const EmbroideryLineSneakPeek: FC<Props> = ({ properties, hasLogoSetup }) => {
  const {
    embroidery: {
      cart: { textTitle, iconTitle, logoTitle },
    },
  } = useTranslation()

  const hasText = properties.text_placement
  const hasB2bLogo = properties._logo_image_source
  const hasIcon = properties._icon_image_source && properties.icon_placement
  const hasDtcLogo = properties._logo_preview

  const version = properties._embroidery_version
  const textPlacement = formatPlacementAttribute(properties.text_placement, version)
  const iconPlacement = formatPlacementAttribute(properties.icon_placement, version)
  const logoPlacement = formatPlacementAttribute(properties.logo_placement, version)
  return (
    <>
      {hasText && (
        <>
          <EmbroideryTitle>{textTitle}</EmbroideryTitle>
          <TextSneakPeek
            role='listitem'
            backgroundColor={properties._scrub_color}
            textColorCssValue={properties._text_thread_color_value}
            textColorDisplayName={properties.text_color}
            textFirstLine={properties.text_first_line}
            textFontCssFamily={properties._text_font_family_value}
            textFontDisplayName={properties.text_font}
            textPlacement={textPlacement}
            textSecondLine={properties.text_second_line}
          />
        </>
      )}
      {hasB2bLogo && (
        <>
          <EmbroideryTitle>{logoTitle}</EmbroideryTitle>
          <B2bLogoSneakPeek
            role='listitem'
            backgroundColor={properties._scrub_color}
            imgSrc={properties._logo_image_source}
            logoName={properties.logo_name}
            logoPlacement={logoPlacement}
          />
        </>
      )}
      {hasDtcLogo && (
        <>
          <EmbroideryTitle>{logoTitle}</EmbroideryTitle>
          <DTCLogoSneakPeek
            role='listitem'
            backgroundColor={properties._scrub_color}
            imgSrc={properties._logo_preview}
            logoName={properties.logo_name}
            logoPlacement={logoPlacement}
            logoColor={properties.logo_color_option}
            logoNote={properties.logo_note}
            hasLogoSetup={hasLogoSetup}
          />
        </>
      )}
      {hasIcon && (
        <>
          <EmbroideryTitle>{iconTitle}</EmbroideryTitle>
          <IconSneakPeek
            role='listitem'
            backgroundColor={properties._scrub_color}
            iconImageSource={properties._icon_image_source}
            iconInitials={properties.icon_initials}
            iconInitialsColorCss={properties._icon_thread_color_value}
            iconInitialsColorDisplayName={properties.icon_initials_color}
            iconDesignName={properties.icon_design}
            iconPlacement={iconPlacement}
          />
        </>
      )}
    </>
  )
}
